import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, ShieldCheck } from "lucide-react";
import { BUSINESS, NAV } from "../../content/site";

const cols = ["Plumbing", "Drain & Sewer", "Water Heaters", "About"];

export const Footer = () => (
  <footer className="bg-plum-deep pb-[calc(6rem+env(safe-area-inset-bottom))] text-white/80 lg:pb-0" data-testid="site-footer">
    <div className="container-x grid gap-12 py-16 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <div className="inline-block rounded-2xl bg-white p-3">
          <img src="https://irp.cdn-website.com/90d98ddf/dms3rep/multi/opt/plumb-smart-logo-400w.png" alt="PlumbSmart Plumbing & Drains logo" width="400" height="179" loading="lazy" className="h-16 w-auto" />
        </div>
        <p className="mt-5 max-w-sm text-sm leading-relaxed">
          Residential and commercial plumbing in Asheville, NC and surrounding Western North Carolina communities since {BUSINESS.since}.
        </p>
        <ul className="mt-6 space-y-3 text-sm">
          <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" /><span data-testid="footer-address">{BUSINESS.street}<br />{BUSINESS.cityLine}</span></li>
          <li className="flex items-center gap-3"><Phone className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" /><a href={BUSINESS.phoneHref} className="inline-flex min-h-[44px] items-center font-semibold text-white hover:text-gold sm:min-h-0" data-testid="footer-phone-link">{BUSINESS.phone}</a></li>
          <li className="flex gap-3"><ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" /><span>Contractor License {BUSINESS.license}</span></li>
        </ul>
        <div className="mt-6 flex items-start gap-3 text-sm">
          <Clock className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
          <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1" data-testid="footer-hours">
            {BUSINESS.hours.map(([d, h]) => (<div key={d} className="contents"><dt className="text-white/60">{d}</dt><dd>{h}</dd></div>))}
          </dl>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
        {cols.map((label) => {
          const g = NAV.find((n) => n.label === label);
          return (
            <div key={label}>
              <p className="font-display text-base font-bold text-white">{label}</p>
              <ul className="mt-3 space-y-0.5 text-[15px] sm:mt-4 sm:space-y-1 sm:text-sm">
                {g.columns.flatMap((c) => c.links).slice(0, 7).map(([l, href]) => (
                  <li key={href + l}><Link to={href} className="inline-flex min-h-[44px] items-center hover:text-gold sm:min-h-0 sm:py-1">{l}</Link></li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col items-center justify-between gap-4 py-6 text-sm sm:flex-row sm:text-xs">
        <p className="order-last sm:order-none">© {new Date().getFullYear()} PlumbSmart Plumbing &amp; Drains. All rights reserved.</p>
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-1 [&>a]:py-2 sm:[&>a]:py-0">
          <Link to="/water-filtration-conditioning-ystems" className="hover:text-gold">Water Filtration</Link>
          <Link to="/commercial-plumbing" className="hover:text-gold">Commercial</Link>
          <Link to="/protection-plans" className="hover:text-gold">Protection Plans</Link>
          <Link to="/blog" className="hover:text-gold">Blog</Link>
          <Link to="/faqs" className="hover:text-gold">FAQ</Link>
          <Link to="/contact" className="hover:text-gold">Contact</Link>
          <a href={BUSINESS.bbb} target="_blank" rel="nofollow noopener noreferrer" className="hover:text-gold">BBB Profile</a>
        </div>
      </div>
    </div>
  </footer>
);
